import React from 'react';
import { QRCodeSVG } from 'qrcode.react'; // Import QRCodeSVG for rendering QR code as SVG
import styles from '../styles/styles.module.css';

interface QrCodeInterface {
  qrCodeUrl: string | null;
}

const QrCode: React.FC<QrCodeInterface> = ({ qrCodeUrl }) => {
  return (
    <div>
      {qrCodeUrl ? (
        <div className={styles.qrContainer}>
          <p className={styles.qrHeadline}>
            Scan this QR code with your authenticator app:
          </p>
          {/* Render the QR code */}
          <div className={styles.codeContainer}>
            <QRCodeSVG className={styles.qrCode} value={qrCodeUrl} size={175} />
          </div>
        </div>
      ) : (
        <p>No QR code available.</p>
      )}
    </div>
  );
};

export default QrCode;
